import { createSvg } from '@r1-frontend/ui-kit/atoms/svg/createSvg';

const ArrowLeft = ({ strokeWidth = 1.5 }: { strokeWidth?: number }): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M15 6L9 12L15 18'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    );
};

export default createSvg(ArrowLeft, 'arrow-left');

